// extracted by mini-css-extract-plugin
export default {"tableSection":"B4VUwOsqxJ87PjmhQg2k","contactNotificationPage":"KhOXdI3vkOTmk7o8YQI8"};